import { styled, Typography } from "@mui/material";
import { palette } from "~/theme";

export const InputLabel = styled(Typography)`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: ${palette.primary.gray600};
`;
